var _defs, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 98,
    height: 90,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 98 89.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil0,.fil2{fill:#088551;fill-rule:nonzero}.fil0{fill:#6c6c6f}"))), /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_3044478004112",
    d: "M86.17 39.39c-.9-3.51-2.29-6.83-4.09-9.88l8.36-8.36L76.86 7.56l-8.37 8.36a38.22 38.22 0 0 0-9.88-4.09V0H39.39v11.83c-3.51.91-6.83 2.29-9.88 4.09l-8.36-8.36L7.56 21.15l8.36 8.36c-1.8 3.05-3.18 6.37-4.09 9.88H0v19.22H19.81c-1-3.03-1.56-6.25-1.56-9.61 0-3.36.56-6.58 1.56-9.61.48-1.46 1.08-2.87 1.76-4.23a30.79 30.79 0 0 1 13.59-13.59c1.36-.68 2.77-1.28 4.23-1.76a30.566 30.566 0 0 1 23.45 1.76 30.79 30.79 0 0 1 13.59 13.59c.68 1.36 1.28 2.77 1.76 4.23 1 3.03 1.56 6.25 1.56 9.61 0 3.36-.56 6.58-1.56 9.61H98V39.39H86.17z",
    className: "fil0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_3044478004928",
    d: "M39.03 25.92h-3.98v10.27l-5.98 2.8V53.7l13.95 4.91V32.46l-3.99 1.86z",
    style: {
      fill: "#424045",
      fillRule: "nonzero"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_3044478008000",
    d: "M56.97 29.19v4.9l-11.96-4.9v29.42l23.92-3.27V34.09l-11.96-4.9zm-6.22 11.73h-2.87v-2.35h2.87v2.35zm7.66 0h-2.87v-2.35h2.87v2.35zm7.65 0h-2.87v-2.35h2.87v2.35z",
    className: "fil0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3044478007616"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4 66.78c3.12 0 5.39 1.39 6.88 2.88l-2.75 3.08c-1.11-1.01-2.17-1.66-4.06-1.66-3.39 0-5.83 2.68-5.83 7.12 0 4.54 2.06 7.19 6.23 7.19.89 0 1.8-.24 2.34-.68v-3.79h-3.66v-4.07h8.1v10.17c-1.59 1.38-4.34 2.67-7.42 2.67-5.97 0-10.71-3.89-10.71-11.32 0-7.32 4.88-11.59 10.88-11.59zM52.12 67.19h7.56c4.61 0 8.17 1.25 8.17 5.49 0 1.96-1.16 4.1-3.73 4.78v.13c3.15.58 4.81 2.24 4.81 5.19 0 4.51-3.79 6.51-8.61 6.51h-8.2v-22.1zm7.32 8.91c2.44 0 3.53-1.05 3.53-2.71s-1.16-2.34-3.46-2.34h-2.37v5.05h2.3zm.47 9.32c2.72 0 4.14-1.01 4.14-3.01 0-1.94-1.39-2.78-4.14-2.78h-2.77v5.79h2.77z",
    className: "fil2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.48e9a93b7546ca64d5bc00f7cbf63e15.svg";
export { ForwardRef as ReactComponent };